import { memo, ReactNode } from 'react';
import { SearchableText } from 'ui-beta/searchableText';

import { useTreeViewContext } from './context/TreeViewContext';
import { AtomicEntry, Combine, NodeType } from './types';
import { convertToString } from './convertToString';
import { ComponentTypes, useGetTreeComponent } from './hooks';

type JsonLeafProps = {
  inArray?: boolean;
  isLast?: boolean;
  label: string;
  type: NodeType;
  value: AtomicEntry;
};

type NestedTableLeafProps = {
  value: NonNullable<ReactNode>;
  color?: string;
  depth?: number;
};

type TreeLeafProps = Combine<JsonLeafProps, NestedTableLeafProps>;

export const TreeLeaf = ({ inArray, label, type, value, depth = 0, ...props }: TreeLeafProps) => {
  const { highlight, isNestedTable } = useTreeViewContext();
  const stringValue = convertToString(value as AtomicEntry);
  const newDepth = depth + 1;

  const LeafComponent = useGetTreeComponent(ComponentTypes.leaf);

  return (
    <LeafComponent
      label={
        !inArray && typeof label === 'string' ? (
          <SearchableText searchText={highlight} text={label} />
        ) : (
          label
        )
      }
      inArray={inArray}
      type={type}
      value={isNestedTable ? value : <SearchableText searchText={highlight} text={stringValue} />}
      depth={newDepth}
      {...props}
    />
  );
};

export const MemoTreeLeaf = memo(TreeLeaf);
